/**
 * Home page - This component is no longer used as redirection
 * is now handled directly in App.tsx
 *
 * Keeping this file for backwards compatibility in case it's
 * referenced somewhere in the codebase.
 */

import { Navigate } from 'react-router-dom';

export default function Home(): React.ReactElement {
    // Redirect to root which will be handled by App.tsx
    return <Navigate to="/" replace />;
}
